"use strict";Object.defineProperty(exports, "__esModule", {value: true});

// Recent searches for the search window, kept on this device only, per user
// (the `${userKey}:` prefix that services/persistor uses).

const MAX_RECENT = 5
const keyFor = (userKey) => `${userKey}:searchRecent`

 const loadRecentSearches = (userKey) => {
  try {
    const parsed = JSON.parse(localStorage.getItem(keyFor(userKey)) || '[]')
    return Array.isArray(parsed) ? parsed.filter((q) => typeof q === 'string').slice(0, MAX_RECENT) : []
  } catch (e) {
    return []
  }
}; exports.loadRecentSearches = loadRecentSearches

const save = (userKey, list) => {
  try {
    localStorage.setItem(keyFor(userKey), JSON.stringify(list))
  } catch (e2) {
    // Storage full or blocked: recent searches are a convenience.
  }
  return list
}

 const addRecentSearch = (userKey, query) => {
  const q = query.trim()
  const current = exports.loadRecentSearches.call(void 0, userKey)
  if (!q) return current
  const rest = current.filter(item => item.toLowerCase() !== q.toLowerCase())
  return save(userKey, [q, ...rest].slice(0, MAX_RECENT))
}; exports.addRecentSearch = addRecentSearch

 const removeRecentSearch = (userKey, query) =>
  save(userKey, exports.loadRecentSearches.call(void 0, userKey).filter(item => item !== query)); exports.removeRecentSearch = removeRecentSearch
